import {
  PERMISSION_FETCH_REQUEST,
  PERMISSION_FETCH_REQUEST_SUCCESS,
  PERMISSION_FETCH_REQUEST_FAILURE,
  PERMISSION_CLEAN_REQUEST,
} from '../constants/actionTypes';

const INITIAL_STATE = {
  payload: [],
  loading: false,
  errors: {},
};

/**
 * A reducer takes two arguments, the current state and an action.
 */
const permissionsReducer = (state, action) => {
  state = state || INITIAL_STATE;

  switch (action.type) {
    case PERMISSION_FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });

    case PERMISSION_FETCH_REQUEST_SUCCESS:
      return Object.assign({}, state, {
        payload: action.data,
        loading: false,
        errors: {},
      });

    case PERMISSION_FETCH_REQUEST_FAILURE:
      return Object.assign({}, state, {
        loading: false,
        errors: action.error,
      });

    case PERMISSION_CLEAN_REQUEST:
      return Object.assign({}, state, {
        payload: [],
        loading: false,
        errors: {},
      });

    default:
      return state;
  }
};

export default permissionsReducer;
